export default "__VITE_ASSET__DSa84oEm__"